import { render, staticRenderFns } from "./TeamGramIcon.vue?vue&type=template&id=c19c135c"
import script from "./TeamGramIcon.vue?vue&type=script&lang=js"
export * from "./TeamGramIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports